import { MembershipItemSkeleton } from '../MemberShipItem/MemberShipItemSkeleton';

export const MembershipsListSkeleton = () => {
  const toMap = [1, 2, 3];

  return (
    <div className='memberships__list'>
      { toMap.map((e) => <MembershipItemSkeleton key={e} />)}
    </div>
  );
};
